<!-- layouts/default.vue -->
<template>
  <MapaBuscadorGeneral />
  <NuxtLoadingIndicator :color="'white'" :height="5" />
  <NewHeader v-if="motrar_header"/> 
  <ModalExitIntent v-if="mostrar_modal_exit" />
  <ClientOnly>
    <!-- <ModalCarritoAbandonado v-if="mostrar_abandonado"/> -->
  </ClientOnly>

  <main class="">
    <slot />
  </main>
  <Footer />

  <Chat v-if="mostrar_chat"/>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import "~/assets/css/app.css";
import Footer from '~/components/Footers/Footer.vue'
import NewHeader from "~/components/Headers/NewHeader.vue";
import ModalExitIntent from "~/components/Modals/ModalExitIntent.vue";
import MapaBuscadorGeneral from '~/components/Mapas/MapaBuscadorGeneral.vue'
import ModalCarritoAbandonado from '~/components/Modals/ModalCarritoAbandonado.vue'

// CHAT
import Chat from '~/components/Vambee/Chat.vue'

const modo_sistema = useState('modo_sistema');
const route = useRoute();
const config = useRuntimeConfig()

const ruta_bloqueada = 'formulario-campania';

const motrar_header = computed(() => {
  if(modo_sistema.value !== ruta_bloqueada){
    return true;
  } else {
    return false;
  }
});

const modoActual = String(config.public?.modo || process.env.NUXT_MODO || 'PROD').toUpperCase();

const mostrar_chat = computed(() => {
  return route.path.startsWith('/neumaticos/plp');
});

// Popup exit-intent (feature/modal-neumaticos): solo en la PLP y solo en modo DEV hasta su liberación; en PROD sigue
// apagado como en develop. SSR y cliente coinciden mientras NUXT_MODO esté definido al build (runtimeConfig.public.modo).
const mostrar_modal_exit = computed(() => {
  return route.path.startsWith('/neumaticos/plp');
});

const mostrar_abandonado= computed(() => {
  return route.path.startsWith('/neumaticos/plp') && modoActual === 'DEV';
});

</script>

